import React from 'react';
import { Route } from 'react-router-dom';

import Header from '../Header';
import Footer from '../Footer';
import ScrollToTop from '../ScrollToTop';

const Layout = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(matchProps) => (
      <div className="layout" {...matchProps}>
        <ScrollToTop />
        <Header />
        <main>
          <Component {...rest} />
        </main>
        <Footer />
      </div>
    )}
  />
);

export default Layout;
